












import { Component, Prop, Vue } from 'vue-property-decorator';
import ExtLink from '../ext/Link.vue';

@Component({
  components: {
    ExtLink,
  },
})
export default class ComponentsPartsBreadcrumbs extends Vue {
  // Props
  @Prop({ type: Array, default: () => [] })
  items: Array<any>;

  @Prop({ type: Boolean, default: false })
  lastLink: false;

  // computed
  get list() {
    console.log('this.items', this.items);
    return this.items.map((item, index) => {
      return index === this.items.length - 1 && !this.lastLink
        ? { text: item.text }
        : item;
    });
  }
  breadCrumbsClick() {
    window.location.assign('/');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/BreadCrumbs.vue